/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const Footer = props => {
    return (        
        <footer className="container-fluid text-center">
            <a href="#" title="To Top">
                <span className="glyphicon glyphicon-chevron-up"></span>
            </a>
            <p class="text-center">2023 © Web designer Studio - Todos os direitos reservados. Desenvolvido por -&nbsp;
                    <a className="" href="" target="">Web designer Studio</a>
                </p>          
        </footer>
    )
}
export default Footer;